import React from 'react';
import i18n from 'i18next';
import Link from 'next/link';

const MenuSubItem = ({ menu, onClick, depth = 0 }) => {
    const name =
        menu.names?.find((item) => item.langCode === i18n.language)?.name ||
        menu.names?.[0]?.name ||
        '';
    const hasChildren = menu.children?.length > 0;
    const isNested = depth > 0;

    return (
        <li
            style={{
                listStyle: 'none',
                borderLeft: isNested ? '1.5px solid #f0f0f0' : 'none',
            }}
        >
            <Link
                href={menu.url ? '/' + menu.url : '/content/' + menu.id}
                passHref
                onClick={onClick}
                style={{ textDecoration: 'none' }}
            >
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        padding: isNested ? '6px 19px' : '10px 20px',
                        fontSize: isNested ? 11 : 13,
                        fontWeight: 400,
                        color: '#374151',
                        textTransform: 'uppercase',
                        letterSpacing: '0.04em',
                        whiteSpace: 'nowrap',
                        cursor: 'pointer',
                        transition: 'color .15s',
                    }}
                    onMouseEnter={(e) => (e.currentTarget.style.color = 'hsl(var(--primary))')}
                    onMouseLeave={(e) => (e.currentTarget.style.color = '#374151')}
                >
                    {name}
                </div>
            </Link>
            {hasChildren && (
                <ul style={{ padding: 0, margin: 0 }}>
                    {menu.children.map((m, ind) => (
                        <MenuSubItem key={ind} menu={m} onClick={onClick} depth={depth + 1} />
                    ))}
                </ul>
            )}
        </li>
    );
};

export default MenuSubItem;
